import { EDUCATION } from "../../data/resumeData";

function Education() {
    return (
      <section className="fade-in">
        <h2>Education</h2>
        {EDUCATION.map((educationItem, index) => (
          <div key={index}>
          <div className="container">
            <div className="heading-4">
              {educationItem.school}
            </div>
          </div>
          <div className="indent distribute">
            <strong>{educationItem.degree} </strong>
            <span>{educationItem.program}</span>
          </div>
          </div>
        ))}
      </section>
    );
  }
  
  export default Education;